import { cx } from '@linaria/core';
import { HTMLAttributes, ReactNode } from 'react';
import "./Fieldset.linaria.module.css!=!./Fieldset?./Fieldset.linaria.module.css?css=H4sIAAAAAAAAA13RQW7DIBAF0H3vUaldEEHSJo17GITtMSYZgwPEdox696pJ7QDLr3lIf5iN8B0/lVzVfSM/Qqc0GVXt24J+/7xs/obt7n+YptAJK5Um3vRPKy+xXdNiS+O96SI+J3zOOELjox406UEzbJVsI40m1msKvahrpWVaGyHBkOO8N54Tf859Whwx0ZjrrPmuWUBpbA32ORlunBl3MdshPG7EKH1dhkfHmZ9GNWColetR3IoGYVp/j7N2b07XOU1BoJKaKA+dKyrQHuzyovrio4fPfZum0BjtiVMzFHRzsNCt3nGtDkhlmh5+hPuSe7ouc0DO3G2cjQuVQWOLQdg3QmorRrAERQn4vlh/5ELL0e2Dh8kTb4V2jbFdce17sJVwEF2y8VLhNk35Jb/6KVqTuXMrTiaL0aKM3f0vvPK/8SwDAAA="
const fieldsetStyles = "atm_jb_idpfg4 atm_h3_idpfg4 atm_gq_idpfg4 atm_gz_idpfg4 atm_h0_idpfg4 atm_lo_idpfg4 atm_le_idpfg4 atm_lk_idpfg4 atm_ll_idpfg4 atm_3f_idpfg4";
const fullWidthStyles = "atm_vy_1osqo2v";
const legendStyles = "atm_9s_1txwivl atm_h_1h6ojuz atm_vy_1osqo2v atm_lo_idpfg4 atm_lk_idpfg4 atm_ll_idpfg4 atm_c8_wte56h atm_cs_ni7l0g atm_7l_1sywzos atm_t9_angws6 atm_le_ftgil2";
const helperTextStyles = "atm_h3_idpfg4 atm_gq_idpfg4 atm_gz_idpfg4 atm_h0_idpfg4 atm_c8_1skhajo atm_7l_1sywzos";
export interface FieldsetProps extends HTMLAttributes<HTMLFieldSetElement> {
  children?: ReactNode;
  fullWidth?: boolean;
}
export const Fieldset = (props: FieldsetProps) => {
  const {
    children,
    className,
    fullWidth = false,
    ...rest
  } = props;
  return <fieldset className={cx('mfc-fieldset', fieldsetStyles, fullWidth && fullWidthStyles, className)} {...rest}>
            {children}
        </fieldset>;
};
export interface LegendProps extends HTMLAttributes<HTMLElement> {
  children?: ReactNode;
  asDiv?: boolean;
}
export const Legend = (props: LegendProps) => {
  const {
    asDiv = false,
    children,
    className,
    ...rest
  } = props;
  const Tag = asDiv ? 'div' : 'legend';
  return <Tag className={cx('mfc-legend', legendStyles, className)} {...rest}>
            {children}
        </Tag>;
};
export interface HelperTextProps extends HTMLAttributes<HTMLParagraphElement> {
  children?: ReactNode;
}
export const HelperText = (props: HelperTextProps) => {
  const {
    children,
    className,
    ...rest
  } = props;
  return <p className={cx('mfc-helper-text', helperTextStyles, className)} {...rest}>
            {children}
        </p>;
};